import WithDirection from '@app/settings/withDirection';
import { Select } from 'antd';
import { AntSelect } from './styles/select.style';

const WDSelect = AntSelect(Select);

export const IsoSelect = WithDirection(WDSelect);
export const IsoSelectOption = Select.Option;
